

export const HEADER_TYPE = "header";